<template>
    <div>
        <TrialNagModal ref="trialModal"></TrialNagModal>
        <ErrorModal></ErrorModal>
        <vue-topprogress ref="topProgress"></vue-topprogress>
        <router-view></router-view>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import TrialNagModal from "@/components/preview/TrialNagModal";
import ErrorModal from "@/components/general/ErrorModal";
import Poll from "@/mixins/Poll";
import Events from "@/mixins/Events";

export default {
    name: "App",

    components: {
        TrialNagModal,
        ErrorModal
    },

    mixins: [
        //Poll,
        Events
    ],

    created() {

        this.initializeEvents();

        var temp = this;

        var route = JSON.parse(localStorage.getItem("previousRoute"));

        this.$store.dispatch("updateViewPostPage", route);

        this.$store.dispatch("loadServerInfo").then(function () {
            if (temp.serverInfo.is_trial == 1) {
                if (temp.serverInfo.grace_days <= 7) {
                    temp.$refs.trialModal.open();
                }
            }
        });
        this.$store.dispatch("loadUser").then(function () {

            if (temp.category == "") {

                temp.$store.dispatch("updateCategory", "Home");
            }

        });

        this.$store.dispatch("loadEditingState");
    },

    watch: {
        userIsEditing() {
            if (this.socket.closed) {
                this.initializeEvents();
            }
        },
        appLoading(value) {
            if (value) {
                this.$refs.topProgress.start();
            } else {
                this.$refs.topProgress.done();
            }
        },
    },

    computed: {
        ...mapGetters(["user", "category", "serverInfo", "userIsEditing", "appLoading"])
    },
}
</script>

<style lang="less">
@import "@/assets/less/style.less";

//these two styles are to prevent the scrollbar from shifting the content of the page</style>
